import {formatToCurrencyType} from "helper/common";
import React from "react";

const columnHistory: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    align: "center",
  },
  {
    title: "Số phiếu thu",
    dataIndex: "soPhieuThu",
    key: "soPhieuThu",
    // editable: true,
    // width: '13%',
    align: 'center'
  },
  {
    title: "Nội dung thu",
    dataIndex: "noiDung",
    key: "noiDung",
    // editable: true,
    // width: '20%',
    // align: 'right'
  },
  {
    title: "Ngày phiếu thu",
    dataIndex: "ngayPhieuThu",
    key: "ngayPhieuThu",
    align: 'center'
    // editable: true,
    // width: '13%',
    // align: 'right'
  },
  {
    title: "Số tiền",
    dataIndex: "soTien",
    key: "soTien",
    // editable: true,
    // width: '20%',
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Số tiền trả lại",
    dataIndex: "soTienTraLai",
    key: "soTienTraLai",
    // editable: true,
    // width: '20%',
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Mã giao dịch",
    dataIndex: "maGiaoDich",
    key: "maGiaoDich",
    // editable: true,
    // width: '20%',
    align: "center",
  },
  {
    title: "Hình thức TT",
    dataIndex: "hinhThucTT",
    key: "hinhThucTT",
    // editable: true,
    // width: '20%',
    align: "left",
    render: hinhThucTT => {
      if (hinhThucTT == 0)
        return (
          <div className="status-pay">
            <div>Tiền mặt</div>
          </div>
        );
      if (hinhThucTT == 1)
        return (
          <div className="status-pay">
            <div>Chuyển khoản</div>
          </div>
        );
      if (hinhThucTT == 2)
        return (
          <div className="status-pay">
            <div>Quẹt thẻ</div>
          </div>
        );
      //   if (hinhThucTT == 3) return <div className='status-pay'>
      //   <div >Momo</div>
      // </div>;
    },
  },
  {
    title: "Tên thu ngân",
    dataIndex: "nguoiThu",
    key: "nguoiThu",
    // editable: true,
    // width: '14%',
    align: "left",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    // editable: true,
    // width: '14%',
    align: "center",
  },
];

export {columnHistory};
